import { motion } from "framer-motion";

const STEPS = [
  {
    num: "01",
    title: "Écouter",
    text: "Comprendre les enjeux de l'agence, son marché, ses ambitions et son positionnement.",
  },
  {
    num: "02",
    title: "Analyser",
    text: "Identifier les leviers de performance et les opportunités de mise en relation pertinentes.",
  },
  {
    num: "03",
    title: "Agir",
    text: "Accompagner concrètement le développement de l'agence et la concrétisation des opportunités.",
  },
];

export const Approche = () => {
  return (
    <section
      id="approche"
      data-testid="approche-section"
      className="relative bg-[#FAFAFA] py-28 md:py-40 border-t border-[#E5E5E5]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-120px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mb-20 md:mb-28 max-w-3xl"
        >
          <div className="flex items-center gap-4 mb-8">
            <span className="accent-bar-sm" aria-hidden="true" />
            <span className="text-xs tracking-[0.25em] uppercase text-[#6B7280] font-medium">
              Méthode
            </span>
          </div>
          <h2
            data-testid="approche-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#0A0A0A]"
          >
            Notre <span className="italic font-normal">approche.</span>
          </h2>
          <p
            data-testid="approche-subtitle"
            className="mt-8 text-base md:text-lg text-[#374151] font-light max-w-xl leading-relaxed"
          >
            Une méthode rigoureuse, des résultats concrets.
          </p>
        </motion.div>

        {/* Steps */}
        <div className="relative">
          {/* Horizontal connecting line — desktop only */}
          <div
            className="hidden md:block absolute top-[34px] left-[8%] right-[8%] h-px"
            aria-hidden="true"
          >
            <div className="relative w-full h-full">
              <div className="absolute inset-0 bg-[#E5E5E5]" />
              <div className="absolute left-1/2 -translate-x-1/2 top-0 w-16 h-px bg-[#E10600]" />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-10 relative z-10">
            {STEPS.map((step, idx) => (
              <motion.div
                key={step.num}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{
                  duration: 0.8,
                  delay: idx * 0.15,
                  ease: [0.22, 1, 0.36, 1],
                }}
                data-testid={`approche-step-${step.num}`}
                className="flex flex-col items-start md:items-center text-left md:text-center md:px-6"
              >
                {/* Number disc */}
                <div className="relative bg-[#FAFAFA] px-4 md:px-6">
                  <span className="font-serif text-5xl md:text-6xl text-[#E10600] leading-none block">
                    {step.num}
                  </span>
                </div>

                <h3
                  className="font-serif text-2xl md:text-3xl text-[#0A0A0A] mt-8 tracking-tight"
                  data-testid={`approche-step-title-${step.num}`}
                >
                  {step.title}
                </h3>

                <p
                  className="mt-4 text-[0.95rem] text-[#6B7280] font-light leading-relaxed max-w-xs"
                  data-testid={`approche-step-text-${step.num}`}
                >
                  {step.text}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
